import { Box, Chip, Tooltip } from "@mui/material";
import React from "react";

export const initialCreateFormData = {
  COMMUNICATION_TYPE_VIDEO: {
    element_id: "",
    request_type: "CREATE",
    content: [
      {
        lang_code: "en",
        title: "",
        description: "",
      },
    ],
    thumbnail: {
      portrait: "",
      landscape: "",
    },
    is_active: false,
    pass_percentage: 95,
    priority: undefined,
    search_keywords: [],
    buffer_hours: 48,
  },
  ASSESSMENT: {
    element_id: "",
    request_type: "CREATE",
    assessment_type: "QUIZ",

    content: [],
    thumbnail: {
      portrait: "",
      landscape: "",
    },
    is_active: false,
    pass_percentage: 75,
    buffer_hours: 48,
  },
  SERIES: {
    element_id: "",
    request_type: "CREATE",
    content: [],
    thumbnail: {
      portrait: "",
      landscape: "",
    },
    is_active: false,
  },
};

const containerProps = {
  sx: {
    display: "flex",
    gap: 2,
    "& > *": {
      flex: 1,
    },
  },
};

export const initialAssignForm = (elementId, elementType) => {
  switch (elementType) {
    case "COMMUNICATION_TYPE_VIDEO":
      return {
        element_type: elementType,
        element_id: elementId,
        assignment_type: "REPOSITORY",

        entity_type: "City",
        city: "",
        entity_values: [],
        scope: "driver",
      };
    case "ASSESSMENT":
      return {
        element_type: elementType,
        element_id: elementId,
        assignment_type: "MANDATORY",
        type: "csv",
        scope: "driver",
        entity_type: "City",
        city: "",
        entity_values: [],
      };
    case "SERIES":
      return {
        element_type: elementType,
        assignment_type: "MANDATORY",
        element_id: elementId,
        type: "csv",
        scope: "driver",
      };
  }
};

export const generalAssessmentDetails = [
  {
    id: "assessment_type",
    label: "Assessment type",
    containerProps,
    required: true,
    type: "Dropdown",
    props: {
      optionsKey: "assessment_types",
      placeholder: "Select assessment type",
    },
  },
  {
    id: "buffer_hours",
    label: "Mandatory deadline buffer (Hr)",
    containerProps,
    required: false,
    props: {
      type: "number",
      inputProps: {
        min: 0,
      }
    },
  },
  {
    id: "pass_percentage",
    label: "Pass %",
    containerProps,
    required: true,
    props: {
      type: "number",
    },
  },
  {
    id: "randomize_questions",
    label: "Randomize Options",
    containerProps,
    required: true,
    type: "Checkbox",
    props: {
      options: [
        {
          label: "Randomize Questions",
          value: "randomize_questions",
        },
      ],
    },
  },
];

export const randomizeQuestionsAssessmentDetails = [
  {
    id: "randomize_questions_count",
    label: "Random Question Count",
    containerProps,
    required: true,
    props: {
      placeholder: "Randomize Question Count",
      type: "number",
    },
  },
];

export const assessmentDetails = [
  {
    id: "title",
    label: "Title",
    containerProps,
    required: true,
    props: {
      placeholder: "Enter assessment title",
    },
  },
  {
    id: "description",
    label: "Description",
    containerProps,
    required: true,
    props: {
      placeholder: "Enter assessment sub-title",
    },
  },
];

export const generalVideoDetails = [
  {
    id: "tags",
    label: "Video tags",
    type: "Multiselect",
    containerProps,
    required: true,
    props: {
      optionsKey: "tags",
      options: [],
      placeholder: "Select video tag",
    },
  },
  {
    id: "priority",
    label: "Video priority",
    type: "Dropdown",
    required: true,
    containerProps,
    props: {
      options: [],
      placeholder: "Select priority",
    },
  },
  {
    id: "pass_percentage",
    label: "Mandatory Video completion(%)",
    containerProps,
    required: true,
    props: {
      type: "number",
    },
  },
  {
    id: "buffer_hours",
    label: "Mandatory Video deadline buffer (Hr)",
    containerProps,
    required: false,
    props: {
      type: "number",
      inputProps: {
        min: 0,
      }
    },
  },
  {
    id: "search_keywords",
    label: "Keywords",
    containerProps,
    type: "ChipsInput",
    props: {
      placeholder: "Enter video search keywords",
    },
  },
];
export const videoConfig = [
  {
    id: "title",
    label: "Video Title",
    containerProps,
    required: true,
    props: {
      placeholder: "add video title",
    },
  },
  {
    id: "description",
    label: "Video Description",
    containerProps,
    required: true,
    props: {
      placeholder: "add a description",
    },
  },
];
export const videoDurationConfig = [
  {
    id: "duration",
    label: "Video duration",
    required: true,
    containerProps,
    options: {
      regex: /^(?:[1-5]\d|:[0-5]\d|[0-9]):[0-5]\d$/,
      errorMessage: "invalid input, required format mm:ss, eg - 1:50, 12:43",
    },
    props: {},
  },
];

export const priority = [
  {
    label: "Very High",
    value: 5,
  },
  {
    label: "High",
    value: 4,
  },
  {
    label: "Medium",
    value: 3,
  },
  {
    label: "Low",
    value: 2,
  },
  {
    label: "Very Low",
    value: 1,
  },
];

export const pathMappings = {
  video: "COMMUNICATION_TYPE_VIDEO",
  assessment: "ASSESSMENT",
  series: "SERIES",
};

export const pathMappingsReverse = {
  COMMUNICATION_TYPE_VIDEO: "video",
  ASSESSMENT: "assessment",
  SERIES: "series",
};

export const elementType = [
  {
    key: "video",
    value: "COMMUNICATION_TYPE_VIDEO",
    label: "Video",
  },
  {
    key: "assessment",
    value: "ASSESSMENT",
    label: "Assessment",
  },
  {
    key: "series",
    value: "SERIES",
    label: "Series",
  },
];

export const seriesSelection = [
  {
    id: "ref_type",
    label: "Select element type",
    type: "Dropdown",
    containerProps,
    required: true,
    props: {
      options: elementType.filter((item) => item.key !== "series"),
      placeholder: "Select element type",
    },
  },
  {
    id: "ref_id",
    label: "Select element id",
    type: "Autocomplete",
    containerProps,
    required: true,
    props: {
      optionsKey: "ref_ids",
      placeholder: "Select element id",
    },
  },
];

export const assignmentContainerProps = {
  sx: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    gap: 2,
    "& > *": {
      flex: 1,
    },
  },
};
export const assignmentForm = [
  {
    id: "driver_service",
    type: "Multiselect",
    label: "Delivery service",
    containerProps: assignmentContainerProps,
    props: {
      placeholder: "Select delivery service",
      optionsKey: "driver_services",
      required: true,
    },
  },
];
export const geographyScopeForm = [
  {
    id: "entity_type",
    type: "Dropdown",
    label: "Geography scope",
    containerProps: assignmentContainerProps,
    props: {
      required: true,
      placeholder: "Select geography scope",
      optionsKey: "geography_scopes",
    },
  },
];

export const cityForm = [
  {
    id: "selected_city",
    type: "Dropdown",
    label: "Select City",
    containerProps: assignmentContainerProps,
    props: {
      placeholder: "Select city",
      optionsKey: "geography_scopes",
    },
  },
  {
    id: "entity_value",
    type: "Dropdown",
    label: "Geography value",
    containerProps: assignmentContainerProps,
    props: {
      placeholder: "Select geography value",
      options: [],
    },
  },
];
export const entityForm = [
  {
    id: "entity_value",
    type: "Dropdown",
    label: "Geography value",
    containerProps: assignmentContainerProps,
    props: {
      placeholder: "Select geography value",
      options: [],
    },
  },
];

export const createNewElementForm = [
  {
    id: "elementType",
    type: "Dropdown",
    label: "Element type",
    containerProps: assignmentContainerProps,
    props: {
      // disabled: true,
    },
  },
];

const commonProps = {
  flex: 1,
  disableColumnMenu: true,
  sortable: false,
};
export const historyTableColumns = (options) => [
  {
    headerName: "Assignment type",
    field: "assignment_type",
    valueGetter: ({ value }) => {
      return options?.assignment_types
        ?.filter((option) => value === option.value)
        ?.map((item) => item?.label);
    },
    ...commonProps,
  },
  {
    headerName: "Delivery service",
    field: "conditions",
    valueGetter: ({ value }) => {
      const val = JSON.parse(value)?.[0]?.Value;
      const driverServices = options?.driver_services
        ?.filter((option) => (val ?? [])?.includes(option.value))
        ?.map((item) => item?.label);
      return driverServices;
    },

    renderCell: ({ value }) => {
      if (value.length > 2)
        return (
          <Tooltip title={value.join(", ")}>
            <Box display="flex" flexWrap={"wrap"} gap={2} alignItems={"center"}>
              {value?.slice(0, 2)?.map((item) => (
                <Chip label={item} key={item} />
              ))}
              <span>+ {value?.slice(2).length}</span>
            </Box>
          </Tooltip>
        );
      return (
        <Box display="flex" flexWrap={"wrap"} gap={1}>
          {value?.map((item) => (
            <Chip label={item} key={item} />
          ))}
        </Box>
      );
    },
    ...commonProps,
    minWidth: 350,
    width: 350,
  },
  {
    headerName: "Entity type",
    field: "entity_type",
    ...commonProps,
  },
  {
    headerName: "Entity value",
    field: "entity_value_label",
    ...commonProps,
  },
  {
    headerName: "Created at",
    field: "created_at",
    ...commonProps,
  },
  {
    headerName: "Created by",
    field: "created_by",
    minWidth: 250,
    ...commonProps,
  },
];
